/**
 * Módulo de administración. Es además el ejemplo de referencia del registro
 * de módulos: mirá `routes/module.ts` para el contrato completo.
 *
 * Por qué el portal del consumidor cuelga de acá y no es un módulo propio
 * ---------------------------------------------------------------------
 * `layout/nav.ts` declara los módulos de forma **estática** y la barra
 * lateral los filtra sólo por rol. El portal (#46) tiene que aparecer o no
 * según la **marca** —ADR-011 lo prohíbe en tenants farmacéuticos, y ahí la
 * sección no debe existir siquiera en la navegación—, y eso una lista
 * estática no lo puede expresar sin que `Sidebar` consulte a la API.
 *
 * Dentro de este módulo sí se puede: `AdminNav` pregunta por
 * `GET /consumer/portal/config` y agrega la solapa sólo si la marca lo tiene
 * habilitado. Encaja además con lo que el portal es del lado del tenant: un
 * interruptor de cumplimiento, o sea administración.
 *
 * La ruta existe igual en una marca pharma: si alguien pega `/admin/portal`
 * a mano, la vista explica por qué no existe para esa marca — que es lo que
 * hace la API, con un 404 y un motivo, en vez de una pantalla en blanco.
 */
import { Navigate } from 'react-router-dom';

import type { ModuleRoutes } from '../module';
import { PortalPage } from '../portal/PortalPage';
import { AuditPage } from './AuditPage';
import { UsersPage } from './UsersPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'admin',
  // Usuarios, roles y auditoría: sólo admin. La API devuelve 403 igual.
  minimumRole: 'admin',
  routes: [
    { path: '', element: <Navigate to="/admin/users" replace /> },
    { path: 'users', element: <UsersPage /> },
    { path: 'audit', element: <AuditPage /> },
    { path: 'portal', element: <PortalPage /> },
  ],
};
